import { GetterTree } from 'vuex';
import { EvaluatorState } from './types';
import { RootState } from '@/store/types';
import { GoalQueryParams } from '@/api/requests/evaluator/types';

export const getters: GetterTree<EvaluatorState, RootState> = {

    /**
     * Check if evaluator module is enabled.
     * @param state
     * @param nlGetters
     * @param rootState
     * @param rootGetters
     */
    evaluatorModuleEnabled: (state, nlGetters, rootState, rootGetters): boolean => {
        return rootGetters.permissionEnabled('evaluators');
    },

    //check goal permissions

    /**
     * Check if goal module is enabled.
     * @param state
     * @param nlGetters
     * @param rootState
     * @param rootGetters
     */
    goalModuleEnabled: (state, nlGetters, rootState, rootGetters): boolean => {
        return rootGetters.permissionEnabled('goals');
    },

    /**
     * Check if user can create goal.
     * @param state
     * @param nlGetters
     * @param rootState
     * @param rootGetters
     */
    canCreateGoal: (state, nlGetters, rootState, rootGetters): boolean => {
        return rootGetters.permissionEnabled('goals.create');
    },

    /**
     * Check if user can view all goal.
     * @param state
     * @param nlGetters
     * @param rootState
     * @param rootGetters
     */
    canViewAnyGoal: (state, nlGetters, rootState, rootGetters): boolean => {
        return rootGetters.permissionEnabled('goals.viewAny');
    },

    /**
     * Check if user can view goal.
     * @param state
     * @param nlGetters
     * @param rootState
     * @param rootGetters
     */
    canViewGoal: (state, nlGetters, rootState, rootGetters): boolean => {
        return rootGetters.permissionEnabled('goals.view');
    },

    /**
     * Check if user can update goal.
     * @param state
     * @param nlGetters
     * @param rootState
     * @param rootGetters
     */
    canUpdateGoal: (state, nlGetters, rootState, rootGetters): boolean => {
        return rootGetters.permissionEnabled('goals.update');
    },

    /**
     * Check if user can delete goal.
     * @param state
     * @param nlGetters
     * @param rootState
     * @param rootGetters
     */
    canDeleteGoal: (state, nlGetters, rootState, rootGetters): boolean => {
        return rootGetters.permissionEnabled('goals.delete');
    },

    /**
     * Get the active goal.
     *
     * @param state
     * @param myGetters
     */
     activeGoal: (state, myGetters) => {
        return myGetters.getGoalById(state.activeGoalId);
    },

    /**
     * Return the specified goal.
     *
     * @param state
     */
    getGoalById: (state) => (id: number) => {
        return state.goals.find((goal) => goal.id === id);
    },

    /**
     * Check if goal is in collection.
     *
     * @param state
     * @param myGetters
     */
    isGoalLoaded: (state, myGetters) => (id: number): boolean => {
        return !!myGetters.getGoalById(id);
    },

    /**
     * Get http filters.
     *
     * @param state
     */
    httpFilters: (state): GoalQueryParams => ({
        ...state.filters,
    }),

    //check package permissions

    /**
     * Check if package module is enabled.
     * @param state
     * @param nlGetters
     * @param rootState
     * @param rootGetters
     */
    packageModuleEnabled: (state, nlGetters, rootState, rootGetters): boolean => {
        return rootGetters.permissionEnabled('packages');
    },

    /**
     * Check if user can manage package.
     * @param state
     * @param nlGetters
     * @param rootState
     * @param rootGetters
     */
    canManagePackage: (state, nlGetters, rootState, rootGetters): boolean => {
        return rootGetters.permissionEnabled('packages.management');
    },

    /**
     * Check if user can create package.
     * @param state
     * @param nlGetters
     * @param rootState
     * @param rootGetters
     */
    canCreatePackage: (state, nlGetters, rootState, rootGetters): boolean => {
        return rootGetters.permissionEnabled('packages.create');
    },

    /**
     * Check if user can view all package.
     * @param state
     * @param nlGetters
     * @param rootState
     * @param rootGetters
     */
    canViewAnyPackage: (state, nlGetters, rootState, rootGetters): boolean => {
        return rootGetters.permissionEnabled('packages.viewAny');
    },

    /**
     * Check if user can view package.
     * @param state
     * @param nlGetters
     * @param rootState
     * @param rootGetters
     */
    canViewPackage: (state, nlGetters, rootState, rootGetters): boolean => {
        return rootGetters.permissionEnabled('packages.view');
    },

    /**
     * Check if user can update package.
     * @param state
     * @param nlGetters
     * @param rootState
     * @param rootGetters
     */
    canUpdatePackage: (state, nlGetters, rootState, rootGetters): boolean => {
        return rootGetters.permissionEnabled('packages.update');
    },

    /**
     * Check if user can delete package.
     * @param state
     * @param nlGetters
     * @param rootState
     * @param rootGetters
     */
    canDeletePackage: (state, nlGetters, rootState, rootGetters): boolean => {
        return rootGetters.permissionEnabled('packages.delete');
    },

    /**
     * Return the specified package.
     *
     * @param state
     */
    getPackageById: (state) => (id: number) => {
        return state.packages.find((singlePackage: any) => singlePackage.id === id);
    }
};
